import { render, staticRenderFns } from "./StreamerIcon.vue?vue&type=template&id=3734109a&"
import script from "./StreamerIcon.vue?vue&type=script&lang=js&"
export * from "./StreamerIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports